<template>
  <div class="cadfm-container-horizontal">
            <!-- <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left> -->
            <Middle   :lang="lang.Middle"></Middle>
            <!--<Right v-show="isVisibleRight" :lang="lang.Right"></Right>-->
 </div>
</template>

<script>

import Middle from '@/components/ProjectManager/Views/ProjectImportBomLst/Middle/Middle'
//import Right from '@/components/PartManager/Views/Categories/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'ProjectImportBomLst',
  components:{
    // Left,
    Middle,
    //Right
  },
 props:{
    
    lang: Object
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportBomLst.vue